<aside class="sidebar" [class.open]="isOpen" [class.collapsed]="isCollapsed">
  <!-- Sidebar Header with Logo -->
  <div class="sidebar-header">
    <div class="logo-section">
      <img src="assets/logos/logo.png" alt="AMHA Logo" class="sidebar-logo sidebar-logo-full" />
      <img src="assets/logos/favicon.png" alt="AMHA Logo" class="sidebar-logo sidebar-logo-icon" />
    </div>
  </div>

  <!-- Navigation Content -->
  <div class="sidebar-content">
    <div *ngIf="masterItems.length > 0">
      <div class="nav-section-title" *ngIf="!isCollapsed">
        <span class="material-icons-outlined section-icon">admin_panel_settings</span>
        Masters
      </div>
      <ul class="nav flex-column mb-3">
        <ng-container *ngTemplateOutlet="navItemTemplate; context: { items: masterItems }"></ng-container>
      </ul>
    </div>

    <div *ngIf="entityItems.length > 0">
      <div class="nav-section-title" *ngIf="!isCollapsed">
        <span class="material-icons-outlined section-icon">category</span>
        Clinics
      </div>
      <ul class="nav flex-column mb-3">
        <ng-container *ngTemplateOutlet="navItemTemplate; context: { items: entityItems }"></ng-container>
      </ul>
    </div>

    <ng-template #navItemTemplate let-items="items">
      <li class="nav-item" *ngFor="let item of items">
        <!-- Main Item -->
        <div class="nav-item-wrapper">
          <!-- Item with or without children -->
          <a *ngIf="!item.children || item.children.length === 0" [routerLink]="item.route" routerLinkActive="active"
            class="nav-link" (click)="onLinkClick()">
            <!-- Icon using Material Icons -->
            <span class="nav-icon">
              <span class="material-icons-outlined">{{ item.icon }}</span>
            </span>
            <!-- Label -->
            <span class="nav-label">{{ item.label }}</span>
          </a>

          <!-- Collapsible Parent Item -->
          <button *ngIf="item.children && item.children.length > 0" type="button" class="nav-link parent-nav-link"
            [class.expanded]="isExpanded(item.label)" (click)="toggleExpand(item.label)">
            <!-- Icon using Material Icons -->
            <span class="nav-icon">
              <span class="material-icons-outlined">{{ item.icon }}</span>
            </span>

            <!-- Label -->
            <span class="nav-label">{{ item.label }}</span>

            <!-- Expand Icon for parent items -->
            <span class="expand-icon material-icons" [class.expanded]="isExpanded(item.label)">
              expand_more
            </span>
          </button>

          <!-- Children Items -->
          <ul class="nav flex-column children-nav"
            *ngIf="item.children && item.children.length > 0 && isExpanded(item.label)">
            <li class="nav-item" *ngFor="let child of item.children">
              <a [routerLink]="child.route" routerLinkActive="active" class="nav-link child-link"
                (click)="onLinkClick()">
                <span class="nav-label">{{ child.label }}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
    </ng-template>
  </div>
</aside>